import { SettingsService } from "../../../services/index";

class SettingsCompanyController {
    private company: any;
    private settingsService: any;

    constructor(SettingsService: SettingsService) {
        "ngInject";

        this.settingsService = SettingsService;
    }

    submitSettings() {
        // console.log('submitSettings');

        this.settingsService.customPost('CompanySettings', this.company);
    }
}

export const settingsCompanyComponent = {
    bindings: {
        company : "<"
    },
    controller : SettingsCompanyController,
    template : require("./settings.company.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/company/settings.company.component.ts